import React from 'react';
import { Col, Row, Form, FormGroup, Button, InputGroup, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import wrapWithApiData from '../../wrapWithApiData';
import OrderSearchDataTable from '../OrderSearchDataTable';
import NPPanel from '../../NPPanel';
import LoadingSpinner from '../../LoadingSpinner';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import OrderCreate from '../../OrderCreate';
import queryString from 'query-string';


//import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import 'moment/locale/sv';
import "react-day-picker/lib/style.css";
import './style.scss';
import constants from '../.././util/constants';
import axios from 'axios';
import moment from 'moment';
import _ from 'underscore';
import NPHelpButton from '../../NPHelpButton';
import { Command } from '../../OrderCreate/common';
import ReactGA from 'react-ga';
const { API_BASE_URL } = constants;

const helpNode = (
    <div>
      <h4>Order number</h4>
      <p>If you know the order number, please input the number and press enter, client and exmill values will not affect the search.</p>
      
      <h4>Client</h4>
      <p>If you want to search by the name or number of the client, please select the client from the list.</p>
      <p>When you start typing on the keyboard, only clients that contains the typed letters will appear in the list.</p>

      <h4>Exmill from</h4>
      <p>Select the start date for exmill that the search will be valid for.</p>
      

      <h4>Exmill to</h4>
      <p>Select the end date for exmill that the search will be valid for.</p>
      
      

      <h4>Search</h4>
      <p>Performs a database search with the values selected in the fields described above.
        If you leave order number and client empty, the search will fetch all orders with exmill between 'Exmill from an 'Exmill to'
      </p>


    </div>
  );

const initialFromDate = new Date(new Date().setFullYear(new Date().getFullYear(), new Date().getMonth() - 6, 1)).toISOString().slice(0, 10);
const initialToDate = new Date(new Date().setFullYear(new Date().getFullYear(), new Date().getMonth() + 12, 31)).toISOString().slice(0, 10);

class DayPickerInputWithAddon extends React.Component {

    constructor(props) {
        super(props);

        this.focus = this.focus.bind(this);
    }

    focus() {
        this.inputRef.focus();
    }

    render() {
        const { label, placeholder, disabled, small } = this.props;
        const rest = _.pick(this.props, ['onBlur','onChange','onFocus','onKeyUp', 'value']);

        return (
            <InputGroup className={small ? 'input-group-sm' : ''}>
                <InputGroup.Addon>{label}</InputGroup.Addon>
                <input disabled={disabled} className="form-control" type="text" placeholder={placeholder} {...rest} ref={(input) => { this.inputRef = input }}  />
            </InputGroup>
        )
    }
}



class OrderSearchData extends React.Component {
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.viewOrderCommand=this.viewOrderCommand.bind(this);
        this.state = {
            customer:'',
            ordernumber:'',
            fromdate: initialFromDate,
            todate: initialToDate,
            stillLoading: true,
        };

        this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
        this.getClientCodeData= this.getClientCodeData.bind(this);   
        this.refreshUnderlyingData = this.refreshUnderlyingData.bind(this);
 
    }

    componentDidMount(){
        this.getClientCodeData(true);  
    }


    
    viewOrderCommand(cmd, id, itemId)
    {   
        if (cmd==-1)
        {
            this.search();
        }
        if (cmd==0 && id>0)
        {
            this.state.cmd=cmd;
            this.state.id=id;
            this.state.itemId=itemId;
            this.search();
        }
        else
        {
            this.setState({cmd, id, itemId});
        }     
        
    }
    
    search() {
        let fromdate=moment(this.state.fromdate).format('YYYY-MM-DD');
        let todate=moment(this.state.todate).format('YYYY-MM-DD');

        let apiCalls = {
            orderSearchData: { url: 'Order/GetOrderData2', params: { ordernumber: this.state.ordernumber, customer:this.state.customer, fromdate, todate}}
        };

        this.setState({
            stillLoading: true,
        });

        const callback = (ok) => {
            if(ok) {

            } else {
                alert('Failed to get data');
            }

            this.setState({
                stillLoading: false,
            });
        }

        this.props.reloadData({ apiCalls, callback });
        this.getClientCodeData(true);
    }
    

    getClientCodeData(fromConstructor) {
        let self = this;
        const { API_BASE_URL } = constants;
        const header = {
            'Authorization': 'Bearer ' + this.props.apiToken,
            'Accept': 'application/octet-stream'
        };

        axios.get(API_BASE_URL + 'OrderEntry/GetClientCodeInfo', { headers: header })
            .then(result => {
                if(result.data == null || result.data == undefined){
                    self.setState({stillLoading: false});
                    return;
                }
                if (fromConstructor){
                    self.state["clientCodeList"]=result.data;                    
                    const availableClients = [];
                    result.data.ClientCodes.reduce((acc, curr) => {
                        if(curr.MAIN_CLIENT) {
                            availableClients.push({ value: curr.CLIENT_CODE_REGIONAL, label: curr.CLIENT_CODE_REGIONAL + ' - ' + curr.SHORT_NAME  + ' - ' + curr.DELIVERY_DESTINATION });
                            return availableClients;
                        }
                    }, availableClients);
                    self.state["availableClients"] =availableClients;

                    self.state["stillLoading"] = false;
                    self.forceUpdate();
                }
                else{
                    self.setState({ clientCodeList: result.data, stillLoading: false });
                }
            }
        );
    }

    handleClientSelectChange(item) {
        let value=(item && item.value) || '';
        this.setState({ selectedAvailableClient: item, customer: value });
    }

    GAtrackHandler(e) {
            ReactGA.event({
          category: "User action",
          action: "User made an order search",
          label: "Ordernumber: " +this.state.ordernumber +", Client: "+this.state.selectedAvailableClient + ", From date: " + this.state.fromdate + ", To date: " + this.state.todate
        });  
    }

    refreshUnderlyingData(self){
        let fromdate=moment(this.state.fromdate).format('YYYY-MM-DD');
        let todate=moment(this.state.todate).format('YYYY-MM-DD');
        const header = {
            'Authorization': 'Bearer ' + this.props.apiToken,
            'Accept': 'application/octet-stream'
        };
        
        self.setState({
            isLoading: true
        });

        let params = { ordernumber: this.state.ordernumber, customer:this.state.customer, fromdate, todate};

        axios.get(API_BASE_URL + 'Order/GetOrderData2' + '/?' + queryString.stringify(params), { headers: header})
            .then(result => {
                self.setState({ data: result.data, isLoading: false });
                result.data.foreach((data) => {console.log("test: " + data.REGISTRATION_DATETIME)})
            })
            .catch(response => {
                self.setState({ isLoading: false });
            });
    }
   

    render() {
        const { orderSearchData, isLoading, apiToken, reloadData } = this.props;
        const fromdate=this.state.fromdate && moment(this.state.fromdate).format('YYYY-MM-DD');
        const todate=this.state.todate && moment(this.state.todate).format('YYYY-MM-DD');
        const ordernumber=this.state.ordernumber;
        // let isLoading = this.state.isLoading;
        let orderSearchInformationNode = <LoadingSpinner isLoading={true} />;
        let loadingSpinner = <LoadingSpinner isLoading={isLoading} />;
        let orderFilled=ordernumber.length>0;
        let orderHeader={Text:[]};
        let orderItems=[];
        let data={orderHeader,orderItems};
        let hideOrderSearch=undefined;
        if (this.state.cmd && this.state.cmd>0)
        {
            hideOrderSearch=" ";
            orderSearchInformationNode =<OrderCreate data={data } viewOrderCommand={this.viewOrderCommand} cmd={this.state.cmd} id={this.state.id} itemId={this.state.itemId} clientCodeList={this.state.clientCodeList} apiToken={apiToken} />;
        } else if (orderSearchData) {
            orderSearchInformationNode = <OrderSearchDataTable data={orderSearchData} apiToken={apiToken} refreshData={this.refreshUnderlyingData} reloadData={reloadData} viewOrderCommand={this.viewOrderCommand} getClientCodeData={this.getClientCodeData}/>;
        }
        if (isLoading)
        {
            orderSearchInformationNode=undefined;
        }
        
        const titleNode = (<Form inline autoComplete="off" onSubmit={(evt) => { evt.preventDefault(); this.search() }}>
            <Col sm={12} className="smaller-inputs">    
                <FormGroup>
                    <InputGroup bsSize="small">
                        <InputGroup.Addon>Order number</InputGroup.Addon>
                        <FormControl type="text" defaultValue={ordernumber} placeholder="Order number" onChange={evt => { this.setState({ ordernumber:evt.target.value }) }} />
                    </InputGroup>
                </FormGroup>
        
                <FormGroup className="margin-left-10 select">
                    <InputGroup>
                        <InputGroup.Addon>Client</InputGroup.Addon>
                        <Select isSearchable={true} isClearable={true} resetValue='' options={this.state.availableClients} value={this.state.selectedAvailableClient} onChange={this.handleClientSelectChange} placeholder="Client"
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    minHeight: '25px',
                                    height: '32px'
                                }),
                                valueContainer: (provided) => ({
                                    ...provided,
                                    height: '32px',
                                    minWidth: '150px'
                                }),
                                indicatorsContainer: (provided) => ({
                                    ...provided,
                                    height: '32px',
                                }),
                            }} />
                        {/* <FormControl disabled={orderFilled}  type="text" placeholder="Client" onChange={evt => { this.setState({ customer:evt.target.value }) }} /> */}
                    </InputGroup>
                </FormGroup>
                
            <FormGroup className="margin-left-10">
                <InputGroup bsSize="small">
                        <DayPickerInput
                        label="Exmill from"
                        small
                        disabled={orderFilled}
                        format="YYYY-MM-DD"
                        value={fromdate}
                        onDayChange={(selectedDay) => { this.setState({ fromdate:selectedDay}) }}
                        component={DayPickerInputWithAddon} 
                        />
                </InputGroup>
            </FormGroup>
        
            <FormGroup className="margin-left-10">
                <InputGroup bsSize="small">
                    <DayPickerInput
                        label="Exmill to"
                        small
                        disabled={orderFilled} 
                        format="YYYY-MM-DD" 
                        value={todate}
                        onDayChange={(selectedDay) => { this.setState({ todate:selectedDay }) }}                        
                        component={DayPickerInputWithAddon} {...this.props} 
                        />   
                </InputGroup>
            </FormGroup>
    
            <FormGroup className="margin-left-10">
                <Button type="submit" bsStyle="primary" onClick={()=>this.GAtrackHandler()} bsSize="small">
                    Search
                </Button>
            </FormGroup>


            <FormGroup>
                <div  className="margin-left-10">
                    <NPHelpButton content={helpNode} title="Help" />
                </div>
            </FormGroup>        
        </Col>
    </Form>);

    return (
        <NPPanel isLoading={isLoading && this.state.stillLoading}>
            <Row>
                {!isLoading && !this.state.stillLoading && (hideOrderSearch || titleNode)}
            </Row>
            {isLoading && loadingSpinner}
            {!isLoading &&
                <div className="margin-top-20">
                    {orderSearchInformationNode}
                </div>
            }
        </NPPanel>) 
    }
}

//export default OrderSearchData;
export default wrapWithApiData({
    apiCalls: { 
        orderSearchData: { 
            url: 'Order/GetOrderData2',
            params: {
                fromdate: initialFromDate,
                todate: initialToDate
            }
        },
    },
}, OrderSearchData);